/* eslint-disable */
import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox,
  FormControl,
  InputLabel,
  ListItemIcon,
  ListItemText,
  MenuItem,
  Select
} from '@mui/material';
import translating from '../../../translate.json';

const MultiSelectFilter = ({ field, Controller, control }) => {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let preparedOptions = Array.isArray(field.options)
      ? JSON.parse(JSON.stringify(field.options))
      : [];

    // Remove existing 'all' if exists, then add it first
    preparedOptions = preparedOptions.filter((o) => o.id !== 'all');
    preparedOptions.unshift({ id: 'all', name: translating.all });

    setOptions(preparedOptions);
  }, [field.options]);

  return (
    <FormControl className="filter-input multi-select">
      <InputLabel id={`${field.name}-label`}>{field.label}</InputLabel>
      <Controller
        name={field.name}
        control={control}
        render={({ field: controllerField }) => {
          let selected = Array.isArray(controllerField.value)
            ? controllerField.value
            : ['all'];

          if (typeof selected === 'string') {
            selected = selected.split(',');
          }

          if (selected.length > 1 && selected.includes('all')) {
            selected = selected.filter((v) => v !== 'all');
          }

          const handleChange = (event) => {
            let value = event.target.value;

            if (value.length > 1) {
              value = value.filter((v) => v !== 'all');
            }

            if (!value.length) value = ['all'];

            controllerField.onChange(value);
          };

          return (
            <Select
              multiple
              value={selected}
              onChange={handleChange}
              className="filterInput"
              classes={{ select: 'selectInput' }}
              renderValue={(selectedIds) => {
                if (!selectedIds?.length || selectedIds.includes('all')) {
                  return translating.all;
                }

                const selectedNames = selectedIds
                  .map(
                    (id) =>
                      options.find((o) => String(o.id) === String(id))?.name
                  )
                  .filter(Boolean);

                return selectedNames.join(', ');
              }}
              disableUnderline
            >
              {options.map((option) => (
                <MenuItem key={option.id} value={String(option.id)}>
                  <ListItemIcon>
                    <Checkbox checked={selected.includes(String(option.id))} />
                  </ListItemIcon>
                  <ListItemText primary={option.name} />
                </MenuItem>
              ))}
            </Select>
          );
        }}
      />
    </FormControl>
  );
};

export default MultiSelectFilter;

MultiSelectFilter.propTypes = {
  field: PropTypes.object.isRequired,
  Controller: PropTypes.any.isRequired,
  control: PropTypes.any.isRequired
};
